import { useState, useEffect } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { Offcanvas, Button, Dropdown, ButtonGroup } from "react-bootstrap";
import BarLoader from "../../components/Loader/BarLoader";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import Pagination from "../Constant/Pagination";
import { getVendorAssetUnits } from "../../services/VendorServices";
import { toast } from "react-toastify";
import { CancelRequest } from "../../services/AxiosInstance";
import { UnitStatusBadge } from "../../components";
import { format } from "date-fns";
import { unitStatusOption } from "../../utilities";

function VendorAssetUnits({ show, toggle, vendorId, selectedAsset }) {
  const [assetUnits, setAssetUnits] = useState([]);
  const [assetUnitsLoading, setAssetUnitsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const location = useLocation();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [param, setParam] = useState({
    query: "",
    status: "",
    page: 1,
    page_size: 10,
  });


  useEffect(() => {
    const fetchAssetUnits = async (assetId) => {
      try {
        setAssetUnitsLoading(true);
        const response = await getVendorAssetUnits(vendorId, {...param, asset_id:assetId});
        setAssetUnits(response.data?.data || []);
        setTotal(response.data?.count || 0);
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to fetch units");
        setAssetUnits([]);
      } finally {
        setAssetUnitsLoading(false);
      }
    };
    if (selectedAsset?.asset__id) {
      fetchAssetUnits(selectedAsset.asset__id);
    }
  }, [vendorId, param, selectedAsset]);

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({ ...prev, query: value, page: 1 }));
  };

  const handlePageChange = (page) => {
    setParam((prev) => ({ ...prev, page: page.selected + 1 }));
  };

  return (
    <Offcanvas show={show} onHide={toggle} placement="end" scroll backdrop className="w-40">
      <Offcanvas.Header closeButton className="pb-0">
        <Offcanvas.Title>
          <span className="fw fs-6 text-light">
            Vendor Asset Units 
          </span>
          {selectedAsset && (
            <>
              <span className=" text-dark"> - </span>
              <strong className="fs-5 text-dark">{selectedAsset.asset__name}</strong>
            </>
          )}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="data-table-wrapper mb-3">
          <div className="d-flex align-items-center gap-2">
            <div style={{ flex: 1 }}>
              <DebounceSearchInput handleSearchChange={handleSearchChange} />
            </div>
            <div>
              <Dropdown as={ButtonGroup}>
                <Dropdown.Toggle
                  variant="primary"
                  id="dropdown-basic"
                  className="custom-toggle"
                  style={{
                    height: "43.5px",
                    minWidth: "110px",
                    border: "1px solid #ced4da",
                    boxShadow: "none",
                  }}
                >
                  {unitStatusOption.find(opt => opt.value === selectedStatus)?.label || "Status"}
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-dropdown-menu">
                  {unitStatusOption.map((item) => (
                    <Dropdown.Item
                      className="custom-dropdown-item"
                      key={item.value}
                      onClick={() => {
                        setSelectedStatus(item.value);
                        setParam((prev) => ({
                          ...prev,
                          status: item.value,
                          page: 1,
                        }));
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>Asset Number</th>
                <th>Brand</th>
                <th>Purchase Cost</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {assetUnitsLoading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <BarLoader size={40} color="#255D5C" />
                  </td>
                </tr>
              ) : assetUnits.length > 0 ? (
                assetUnits.map((unit) => (
                  <tr key={unit.id}>
                    <td>
                      <Link
                        to={`/unit/${unit?.id}/basic-details`}
                        className="fw-bold text-primary"
                      >
                        {unit?.asset_number || "-"}
                      </Link>
                    </td>
                    <td>{unit?.brand || "-"}</td>
                    <td>{unit?.purchase_cost || 0}</td>
                    <td>
                      <UnitStatusBadge status={unit?.status} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="mt-3">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default VendorAssetUnits;